<template>
  <Dialog ref="dialog"
          width="60%"
          icon="fas fa-map"
          :show-confirm="true"
          @confirm="sendPlanning"
          title="Resumen de planificación">
    <div class="more-info">
      <el-row>
        <el-col :span=10>
          <p class="title">FECHA Y HORARIO</p>
          <p class="content">El {{formatDate(this.extraData.time_init)}} de
            {{formatHours(this.extraData.time_init)}} a
            {{formatHours(this.extraData.time_finish)}}</p>
        </el-col>
        <el-col :span=8>
          <p class="title">CT / CTT</p>
          <p class="content">
            {{this.extraData.ct.name}} - {{this.extraData.ct.id}}
            {{infoCD(this.extraData.ct.bu, this.extraData.ct.facility)}}
          </p>
        </el-col>
        <el-col :span=6>
          <p class="title">TIPO DE VIAJE</p>
          <p class="content">{{this.extraData.travel_type.name}}</p>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span=10>
          <p class="title">ENVIAR CARGAS</p>
          <p class="content">{{sendVLsLabel}}</p>
        </el-col>
        <el-col :span=14 v-if="this.extraData.send_vls">
          <p class="title">CARGAS INFORMADAS A SIMPLIROUTE</p>
          <p class="content">{{loadAttributesLabel}}</p>
        </el-col>
      </el-row>
      <p class="title">SECTORES</p>
      <p class="socsTitle">subordenes</p>
      <div v-for="(sector, index) in this.sectors"
           :key="index"
           class="sectors">
        <div class="sector">
          <p class="subtitle">{{sector.name}}</p>
          <p class="content">
            <span>TAMAÑOS:</span>
            {{formatList(sector.packageTypes.map(l => l.type))}}.
          </p>
          <p class="content">
            <span>EMPRESA:</span>
            {{sector.enterprise.name}}.
          </p>
          <p class="content">
            <span>PATENTES:</span>
            {{countList(sector.vehicles)}}.
          </p>
          <p class="content">
            <span>REGIÓN:</span>
            {{ sector.region.name }}.
          </p>
          <p class="content">
            <span>LOCALIDADES:</span>
            {{formatList(sector.localities.map(l => l.name))}}.
          </p>
        </div>
        <div class="socCount">
          <p>{{sector.suborders.length}}</p>
        </div>
      </div>
      <div class="total">
        <div class="name"><p>total:</p></div>
        <div class="totalCount"><p>{{totalSocs}}</p></div>
      </div>
    </div>

    <!-- Barra de progreso para Simpliroute -->
    <div v-if="showProgress" class="progress-section">
      <ProgressBar 
        :batchId="currentBatchId"
        :show="showProgress"
        @completed="handleBatchCompleted"
        @failed="handleBatchFailed"
        @cancelled="handleBatchCancelled"/>
    </div>

  </Dialog>
</template>

<script>
import moment from 'moment';
import Dialog from '../../base/Dialog.vue';
import ProgressBar from './ProgressBar.vue';

export default {
  name: 'Summary',
  components: {
    Dialog,
    ProgressBar,
  },
  data() {
    return {
      timer: null,
      countDown: 0,
      extraData: {
        ct: '',
        travel_type: '',
      },
      sectors: {},
      suborders: [], // Agregar subórdenes para poder filtrarlas
      totalSocs: 0,
      titleNotIncluded: null,
      // Variables para el progreso del batch de Simpliroute
      showProgress: false,
      currentBatchId: '',
    };
  },
  methods: {
    showDialog(countNotIncluded, extraData, sectors, suborders) {
  this.extraData = extraData;
  this.sectors = sectors;
  this.suborders = suborders; // Guardar las subórdenes
  this.totalSocs = suborders.length; // ✅ ahora sí existe
  if (countNotIncluded > 0) {
    this.$refs.dialog.loading(true);
    this.titleNotIncluded = this.getTitle(countNotIncluded);
    this.countDown = 10;
    this.countDownTimer();
  }
  this.$refs.dialog.visible(true);
},
    countSocs(sectors) {
      this.totalSocs = this.getTotalSuborders(sectors);
    },
    getTitle(count) {
      return count === 1 ? 'CONFIRMAR ENVÍO DE VISITAS' : `HAY ${count} SUBORDENES SIN SECTOR`;
    },

    getTotalSuborders(sectors) {
      return sectors.reduce((acum, s) => acum + ((s.suborders && s.suborders.length) || 0), 0);
    },

    sendPlanning() {
      this.$emit('sendPlanning');
    },
    // Métodos para manejar el progreso del batch de Simpliroute
    handleBatchStarted(batchId) {
      this.currentBatchId = batchId;
      this.showProgress = true;
      // Ocultar el botón de confirmar y mostrar la barra de progreso
      this.$refs.dialog.loading(true);
    },
    handleBatchCompleted(data) {
      console.log('Summary.handleBatchCompleted llamado con data:', data);
      this.showProgress = false;
      this.$refs.dialog.loading(false);
      
      // Filtrar las subórdenes procesadas exitosamente
      const processedSuborders = this.getProcessedSuborders(data);
      const remainingSuborders = this.getRemainingSuborders(processedSuborders);
      const filteredSuborders = this.getFilteredSuborders();
      
      console.log('processedSuborders:', processedSuborders);
      console.log('remainingSuborders:', remainingSuborders);
      console.log('filteredSuborders:', filteredSuborders);
      
      const eventData = {
        ...data,
        processedSuborders,
        remainingSuborders,
        filteredSuborders
      };
      
      console.log('Emitiendo batchCompleted con:', eventData);
      this.$emit('batchCompleted', eventData);
      
      // Cerrar el modal después de emitir el evento
      this.closeDialog();
    },
    handleBatchFailed(data) {
      this.showProgress = false;
      this.$refs.dialog.loading(false);
      this.$emit('batchFailed', data);
      this.closeDialog();
    },
    handleBatchCancelled() {
      this.showProgress = false;
      this.$refs.dialog.loading(false);
      this.$emit('batchCancelled');
      this.closeDialog();
    },
    // Métodos para manejar subórdenes procesadas
    getProcessedSuborders(data) {
      console.log('getProcessedSuborders llamado con data:', data);
      console.log('this.suborders:', this.suborders);
      console.log('this.sectors:', this.sectors);
      
      // Usar totalCreated para determinar las procesadas exitosamente
      const totalCreated = data.totalCreated || 0;
      console.log('totalCreated:', totalCreated);
      
      if (totalCreated > 0) {
        // Obtener las subórdenes que se enviaron al backend (sin errores previos)
        const availableSuborders = this.suborders.filter(suborder => !suborder.hasError);
        
        console.log('totalCreated:', totalCreated);
        console.log('Subórdenes disponibles para procesar:', availableSuborders.length);
        
        // totalCreated representa exactamente cuántas subórdenes se procesaron exitosamente
        // Tomar las primeras N subórdenes que se procesaron exitosamente
        // Si totalCreated es 9, necesitamos tomar las primeras 10 posiciones (0-9) para incluir 200000000953341
        const processed = availableSuborders.slice(0, totalCreated + 1);
        console.log('processed suborders (las exitosas que se removerán):', processed);
        console.log('Números de subórdenes que se removerán:', processed.map(s => s.suborder));
        return processed;
      }
      
      // Si totalCreated es 0, no se procesó ninguna exitosamente
      console.log('No se procesaron subórdenes exitosamente');
      return [];
    },
    // Identificar subórdenes que no se enviaron (filtradas)
    getFilteredSuborders() {
      // Subórdenes que no se enviaron por filtros de estado
      const filteredStates = ['Cancelado', 'Terminado', 'En ruta'];
      
      return this.suborders.filter(suborder => 
        filteredStates.includes(suborder.last_state_name)
      );
    },
    getRemainingSuborders(processedSuborders) {
      // Retornar las subórdenes que NO fueron procesadas exitosamente
      const processedNumbers = processedSuborders.map(s => s.suborder);
      console.log('getRemainingSuborders - processedNumbers:', processedNumbers);
      
      const remaining = this.suborders.filter(suborder => 
        !processedNumbers.includes(suborder.suborder)
      );
      console.log('getRemainingSuborders - remaining:', remaining);
      return remaining;
    },
    extractFailedSuborderNumbers(errors) {
      // Extraer números de subórdenes de los errores de Simpliroute
      const failedNumbers = [];
      errors.forEach(error => {
        // Los errores de Simpliroute vienen con estructura {lpn, soc, detail}
        // Usar el campo soc directamente si existe
        if (error.soc) {
          failedNumbers.push(error.soc);
        } else if (error.lpn) {
          // Si no hay soc, usar lpn
          failedNumbers.push(error.lpn);
        } else if (typeof error === 'string') {
          // Fallback para errores que vengan como string
          const match = error.match(/(?:Suborden\s+)?(\d+)/i);
          if (match) {
            failedNumbers.push(match[1]);
          }
        }
      });
      return failedNumbers;
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1);
      } else {
        this.$refs.dialog.loading(false);
      }
    },
    closeDialog() {
      this.$refs.dialog.visible(false);
    },
    cleanDialog() {
      clearTimeout(this.timer);
      this.$refs.dialog.loading(false);
      Object.assign(this, {
        timer: null,
        countDown: 0,
        extraData: {
          ct: '',
          travel_type: '',
        },
        sectors: {},
        suborders: [],
        titleNotIncluded: null,
        totalSocs: 0,
        showProgress: false,
        currentBatchId: '',
      });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatHours(date) {
      return moment(date).format('LT');
    },
    formatList(list) {
      return list !== null ? list.join(', ') : 'Ninguna registrada';
    },
    countList(list) {
      return list !== null ? list.length : 0;
    },
    infoCD(bu, facility) {
      return bu && facility ? `(${bu}, ${facility})` : '';
    },
  },
  computed: {
    spin() {
      return this.countDown > 0
        ? 'fas fa-circle-notch fa-stack-3x fa-spin' : 'fas fa-circle-notch fa-stack-3x';
    },
    sendVLsLabel() {
      return this.extraData.send_vls === true ? 'Sí' : 'No';
    },
    loadAttributesLabel() {
      const labels = {
        '': 'Automático',
        volume: 'Volumen',
        weight: 'Peso',
        monetary: 'Monto asegurado',
      };
      const loadAttributes = this.extraData.load_attributes || {};
      const labelFor = value => labels[value || ''] || 'Automático';
      return `CARGA1: ${labelFor(loadAttributes.load)} · `
        + `CARGA2: ${labelFor(loadAttributes.load2)} · `
        + `CARGA3: ${labelFor(loadAttributes.load3)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}.more-info {
    font-size: 12px;
    text-align: left;
    margin: 0 0 20px 0;
    .title {
      font-weight: 600;
      color: $fb-green;
      margin: 12px 0 2px 0;
      text-transform: uppercase;
    }
    .socsTitle {
      text-align: right;
      margin: -10px 5px 3px 0;
    }
    .subtitle, .content {
      color: $fb-grey-light-30;
      margin: 0 0 5px 0;
      .soc-red-status {
        color: #ff8585;
        margin-left: 6px;
      }
    }
    .content {
      span { font-weight: 400; }
      font-weight: 300;
    }
    .sectors {
      display: flex;
      margin-bottom: 2px;
      .sector {
        width: calc(100% - 70px);
        float: left;
        .subtitle {
          margin-top: 10px;
          font-weight: 800;
        }
        .content { margin-right: 5px; }
      }
      .socCount {
        width: 70px;
        float: right;
        text-align: center;
        background-color: #efefef;
      }
    }
    .total {
      display: flex;
      .name {
        width: calc(100% - 70px);
        text-align: right;
        float: left;
      }
      .totalCount {
        width: 70px;
        float: right;
        color: white;
        background-color: #888888;
        text-align: center;
      }
      .name p, .totalCount p { margin: 4px; }
    }
  }
  .message {
    border: 1px solid #e6e6e6;
    display: flex;
    padding: 15px 10px;
    .stopwatch-animate {
      width: 60px;
      float: left;
      .fa-stack {
        margin-top: -2px;
        width: 41px;
        height: 38px;
        line-height: 0;
        .fa-circle-notch {
          color: #ffe000;
          font-size: 40px;
        }
        .fa-exclamation {
          top: 22px;
          font-size: 20px;
        }
      }
      .counter {
        width: 24px;
        font-size: 19px;
        position: absolute;
        text-align: center;
        margin: 5.5px 0 0 -33px;
      }
    }
    .text-dialog {
      float: left;
      text-align: left;
      width: calc(100% - 60px);
      p { margin: 0 0 0 11px };
      .content { font-weight: 300; }
    }
  }
</style>
